type SerialLoaderOptions = {
  /** When true, schedule one more run after the current request finishes. */
  coalesce?: boolean;
};

/**
 * Ensures only one async load runs at a time. Interval ticks are dropped while in flight;
 * optional coalesce runs once more when a tick/event arrived during an active request.
 */
export function createSerialLoader(loadFn: () => Promise<void>): {
  run: (options?: SerialLoaderOptions) => void;
  isRunning: () => boolean;
} {
  let inFlight = false;
  let coalesced = false;

  const run = (options?: SerialLoaderOptions) => {
    if (inFlight) {
      if (options?.coalesce) {
        coalesced = true;
      }
      return;
    }

    inFlight = true;
    void (async () => {
      try {
        await loadFn();
      } finally {
        inFlight = false;
        if (coalesced) {
          coalesced = false;
          run();
        }
      }
    })();
  };

  return {
    run,
    isRunning: () => inFlight,
  };
}
